import moment from "moment";

export const date = (value, mask) => {
	if (!value) return '';

	if( !!mask ){
		return typeof value ? moment(String(value), mask).format('MM/DD/YYYY') : value;
	} else {
		return typeof value ? moment(String(value)).format('MM/DD/YYYY') : value;
	}
};
